import { ClassNameMap, Styles, WithStylesOptions } from '@material-ui/core/styles/withStyles';
import muiMakeStyles from '@material-ui/core/styles/makeStyles';
import { useTheme as MuiUseTheme } from '@material-ui/core/styles';
import { RemotasksUITheme } from './theme';
import { PartialRecord } from '@scale/shared/types/utils';

export type StylesHook<P extends {} = {}, C extends string = string> = (
  props?: P,
) => ClassNameMap<C>;

export type { ClassNameMap } from '@material-ui/core/styles/withStyles';

export const useTheme = () => MuiUseTheme<RemotasksUITheme>();

export function makeStyles<Props extends {} = {}, ClassKey extends string = string>(
  styles: Styles<RemotasksUITheme, Props, ClassKey>,
  options?: Omit<WithStylesOptions<RemotasksUITheme>, 'withTheme'>,
) {
  return muiMakeStyles<RemotasksUITheme, Props, ClassKey>(styles, options) as StylesHook<
    Props,
    ClassKey
  >;
}

type Classes<K extends string> = PartialRecord<K, string>;

export function mergeClasses<K extends string>(
  baseClasses: Classes<K>,
  newClasses?: Classes<K> | undefined,
): Classes<K> {
  if (!newClasses) {
    return baseClasses;
  }
  const nextClasses: Classes<K> = { ...baseClasses };
  keys(newClasses).forEach((key: K) => {
    if (baseClasses[key] && newClasses[key]) {
      nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    } else {
      nextClasses[key] = newClasses[key];
    }
  });
  return nextClasses;
}

function keys<T extends Record<string, any>>(obj: T): (keyof T)[] {
  return Object.keys(obj) as (keyof T)[];
}

export function rgba(hex: string, alpha: number): string {
  const color = longhand(hex).replace('#', '');
  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

function longhand(hex: string): string {
  if (hex.length === 3 || (hex.length === 4 && hex[0] === '#')) {
    return hex.replace(/([0-9a-fA-F])/g, '$1$1');
  } else {
    return hex;
  }
}
